import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
//import EmptyTextArea from './EmptyTextArea';

import './Components.css';

const FinalPage = ({ onSubmit, onPrev, evaluation, inputChange }) => {
  const [cvFile, setCVFile] = useState(null);
  const [cvFileUploadStatus, setCVFileUploadStatus] = useState(false);
  const [cvFileUploadAttempted, setCVFileUploadAttempted] = useState(false);
  const [cvFileUploadFailedMessage, setCVFileUploadFailedMessage] = useState("");
  const handleInputChange = (e) => {
    // Handle input change
    const name = e.target.name;
    let value;
    if(e.target.type === "number"){
      value = parseInt(e.target.value);
    } else {
      value = e.target.value;
    }
    inputChange(name, value);
  };

  const handleCVBrowse = (e) => {
    const file = e.target.files[0];
    setCVFile(file);
    setCVFileUploadStatus(false);
    setCVFileUploadAttempted(false);
  };

  const handleCVUpload = () => {
    if (cvFile && (cvFile.name.includes('.pdf') || cvFile.name.includes('.docx') || cvFile.name.includes('.doc') || cvFile.name.includes('.jpg') || cvFile.name.includes('.png'))) {
      // Perform file upload logic to the server
      const formData = new FormData();
      formData.append('cvFile', cvFile);

      //fetch('https://digitorumflex.com/upload-cv', {
      fetch('https://application.digitorumflex.com/upload-cv.php?password=ryanmilo', {
        method: 'POST',
        body: formData,
      })
        .then((response) => {
          if(response.status === 200){
            console.log('"'+cvFile.name+'" was successfully uploaded!');
            setCVFileUploadStatus(true);
            setCVFileUploadAttempted(true);
          } else {
            console.log("An error occured. Status code "+response.status);
            setCVFileUploadStatus(false);
            setCVFileUploadAttempted(true);
          }
        })
        .catch((error) => {
          console.error(error);
          setCVFileUploadStatus(false);
          setCVFileUploadAttempted(true);
        });
    } else {
      if( !cvFile.name.includes('.pdf') && !cvFile.name.includes('.docx') && !cvFile.name.includes('.doc') && !cvFile.name.includes('.jpg') && !cvFile.name.includes('.png') ){
        setCVFileUploadFailedMessage("Supported formats: .pdf, .docx, .doc, .jpg, .png");
        setCVFileUploadStatus(false);
        setCVFileUploadAttempted(true);
      }
    }
  };

  const handleSubmit = () => {
    // Perform submission logic
    // You can access the comments, remuneration, and cvFile variables here
    onSubmit();
  };

  return (
    <div>
      <Box display="grid" padding={2} justifyContent="center">
          <h2 className="question-h2">Final Page</h2>
          <p>You will be required to upload your CV in order to complete and submit your evaluation.</p>
          <FormControl fullWidth>
            <Box display="grid" paddingTop={2} paddingBottom={2} justifyContent="center">
              <InputLabel htmlFor="Additional Comments" className="centered-label">Additional Comments?</InputLabel>
            </Box>
            <Box display="flex" paddingTop={2} justifyContent="center">
              <Input
                size="large"
                type="text"
                name="Additional Comments"
                value={evaluation["Additional Comments"]}
                onChange={handleInputChange}
                variant="outlined"
                multiline
                minRows={3}
                maxRows={Infinity}
                className="additional-comments"
              />
            </Box>
          </FormControl>
          <FormControl fullWidth>
            <Box display="grid" paddingTop={2} paddingBottom={2} justifyContent="center">
              <Box display="grid" paddingTop={2} justifyContent="center">
                <InputLabel htmlFor="Expected Remuneration" className="centered-label">*Expected Yearly Remuneration (ZAR)</InputLabel>
              </Box>
              <Box display="grid" justifyContent="center">
                <Input
                  type={"text"}
                  name={"Expected Remuneration"}
                  title={"Expected Remuneration"}
                  label={"Expected Remuneration"}
                  value={evaluation["Expected Remuneration"]}
                  onChange={handleInputChange}
                  variant="filled"
                />
              </Box>
            </Box>
          </FormControl>
          <FormControl fullWidth>
            <Box display="grid" paddingTop={2} paddingBottom={4} justifyContent="center">
              <Box display="grid" justifyContent="center">
                <InputLabel htmlFor="cv" className="centered-label">*Upload Your CV:</InputLabel>
              </Box>
              <Box display="grid" paddingTop={2} justifyContent="center">
                <Input
                  type="file"
                  id="cv"
                  accept=".pdf,.doc,.docx,.jpg,.png"
                  onChange={handleCVBrowse}
                />
                <Button variant="outlined" onClick={handleCVUpload}>Upload</Button>
                
                <Box display="grid" justifyContent="center">
                  {cvFileUploadStatus && cvFileUploadAttempted && (
                    <p className="upload-success">CV upload successful!</p>
                  )}
                  {!cvFileUploadStatus && cvFileUploadAttempted && (
                    <div>
                      <p className="upload-failed">CV upload failed. Retry?</p>
                      {cvFileUploadFailedMessage !== "" && (
                        <p className="upload-failed">{cvFileUploadFailedMessage}</p>
                      )}
                    </div>
                  )}
                  {evaluation['submit'] && evaluation['submit attempt'] && (
                    <p className="upload-success">Evaluation submitted!</p>
                  )}
                  {!evaluation['submit'] && evaluation['submit attempt'] && (
                    <div>
                      <p className="upload-failed">Submission failed. Retry?</p>
                      {cvFileUploadFailedMessage !== "" && (
                        <p className="upload-failed">{cvFileUploadFailedMessage}</p>
                      )}
                    </div>
                  )}
                </Box>
              </Box>
            </Box>
          </FormControl>
          <Box display="flex" paddingTop={2} marginBottom={6} justifyContent="center">
            <Button onClick={onPrev}>Previous</Button>
            <Button variant="outlined" 
              disabled={((evaluation["Expected Remuneration"] !== "" && 
              cvFileUploadStatus && cvFileUploadAttempted)?false:true)}
              onClick={handleSubmit}>
              Submit
            </Button>
          </Box>
      </Box>
    </div>
  );
};

export default FinalPage;
